<tn-video-player
  [videoUrl]="sanitize(videoUrl)"
  [filename]="filename"
  [attachmentId]="attachmentId"
  [isDisableWatermark]="isDisableWatermark"
  [isDisableDownload]="isDisableDownload"
  [isChatMessage]="isChatMessage"
  *ngIf="videoUrl"
></tn-video-player>
